/**
 * A token amount that is never rounded away: four decimals at one and above,
 * four significant figures below it, so 0.00000001 reads as itself and not as
 * 0. In the page's own digits.
 */
export function tokenAmount(raw: string | number | null | undefined, locale: string): string | null {
  if (raw === null || raw === undefined || raw === "") return null;
  const n = Number(raw);
  if (!Number.isFinite(n)) return null;
  if (n === 0) return (0).toLocaleString(locale);
  return Math.abs(n) >= 1
    ? n.toLocaleString(locale, { maximumFractionDigits: 4 })
    : n.toLocaleString(locale, { maximumSignificantDigits: 4 });
}
